import {
    ACTION_BIND_BOOLEAN_FALSE,
    ACTION_BIND_BOOLEAN_TRUE,
    ACTION_BIND_NATURAL,
} from '@/workflow-builder/_pure/interaction/actionMapping';
import type { SelectedBindingTarget } from '@/workflow-builder/_contract/selection';

export function isBooleanBindingAction(actionId: string): actionId is typeof ACTION_BIND_BOOLEAN_TRUE | typeof ACTION_BIND_BOOLEAN_FALSE {
    return actionId === ACTION_BIND_BOOLEAN_TRUE || actionId === ACTION_BIND_BOOLEAN_FALSE;
}

export function isNaturalBindingAction(actionId: string): actionId is typeof ACTION_BIND_NATURAL {
    return actionId === ACTION_BIND_NATURAL;
}

export function getSelectedBindingTargetGuardError(args: {
    selectedBindingTarget: SelectedBindingTarget | null;
    expectedResourceTypeHandle: string;
    expectedTypeLabel: 'Boolean' | 'Natural';
}): string | null {
    if (!args.selectedBindingTarget) {
        return 'No selected input role is available for binding.';
    }

    if (args.selectedBindingTarget.resourceTypeHandle !== args.expectedResourceTypeHandle) {
        return `Selected input role '${args.selectedBindingTarget.roleName}' is not a ${args.expectedTypeLabel} input.`;
    }

    return null;
}
